import React from 'react';
import { useState, useCallback } from 'react';
import Header from 'components/ui/Header';
import HeroSection from './components/HeroSection';
import CategoriesGridSection from './components/CategoriesGridSection';
import FeaturesSection from './components/FeaturesSection';
import HowItWorksSection from './components/HowItWorksSection';
import RecensioniSection from './components/RecensioniSection';
import ProProfileShowcaseSection from './components/ProProfileShowcaseSection';
import AreYouAProSection from './components/AreYouAProSection';
import Footer from './components/Footer';
import CTASection from './components/CTASection';


const LandingPage = () => {
  const [toast, setToast] = useState(null);

  const showToast = useCallback((message, type = 'info') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="w-full" style={{ paddingTop: 'var(--header-height)' }}>
        <HeroSection />
        <CategoriesGridSection />
        <FeaturesSection />
        <HowItWorksSection />
        <RecensioniSection showToast={showToast} />
        <ProProfileShowcaseSection />
        <AreYouAProSection />
        <CTASection />
      </main>

      <Footer />
    </div>
  );
};

export default LandingPage;